import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import LandingPage from "@/pages/LandingPage";
import QuizPage from "@/pages/QuizPage";
import AdminPage from "@/pages/AdminPage";
import AgentPage from "@/pages/AgentPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SmoothScroll><LandingPage /></SmoothScroll>} />
          <Route path="/apply" element={<SmoothScroll><QuizPage /></SmoothScroll>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/agent" element={<AgentPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" richColors position={typeof window !== "undefined" && window.innerWidth < 640 ? "top-center" : "top-right"} offset={16} mobileOffset={{ top: 72 }} />
    </div>
  );
}

export default App;
